import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => {
  const itemId = createTemporaryEntityId();
  return {
    data: {
      type: 'paragraph--accordion',
      id: createTemporaryEntityId(),
      attributes: {
        langcode: getEntityTemplateLang(),
        status: true,
        default_langcode: true,
        field_hide_title: false,
        field_search_text: null,
        field_title: { value: 'I am an Accordion Module', format: 'rich_text' },
        field_padding_top: null,
        field_padding_bottom: null,
      },
      relationships: {
        field_items: {
          data: [
            {
              type: 'paragraph--accordion_item',
              id: itemId,
            },
          ],
        },
        field_tags: {
          data: [],
        },
      },
      links: {},
      log: [],
      permissions: {
        update: true,
        create: true,
        delete: true,
      },
    },
    included: [
      {
        type: 'paragraph--accordion_item',
        id: itemId,
        attributes: {
          langcode: 'en',
          status: true,
          default_langcode: true,
          field_search_text: null,
          field_title: { value: 'I am an Accordion Item', format: 'rich_text' },
        },
        relationships: {
          field_modules: {
            data: [
              {
                type: 'paragraph--text_image',
                id: createTemporaryEntityId(),
              },
            ],
            links: {},
          },
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
    ],
  };
};
